module.exports = __webpack_public_path__ + "media/images/products/longlife/icon/chevron-down-green-3f2f4b46e107fc267180cf8bd1ebb726.svg";